












































import {Component, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import NftToggleButton from '@/components/misc/GenericToggleButton.vue'
import NftCollectionToggleButton from '@/components/misc/GenericToggleButton.vue'
import GenericToggleButton from '@/components/misc/GenericToggleButton.vue'

@Component({
  components: {
    GenericToggleButton,
    NftCollectionToggleButton,
    NftToggleButton,
  },
})
export default class LastPriceUpdated extends MixinScreenSize {
  @Prop({type: String, required: true}) lastTimeUpdated!: string
  @Prop({type: Boolean, default: false}) displayInline!: boolean
  @Prop({type: String, required: false, default: 'w-6 h-6 sm:w-7 sm:h-7'})
  iconClass!: string
}
